export default __webpack_public_path__ + "static/freedom-debt-relief-a758e3a63ef9c23d689024c4935a8d82.png";